<template>
	<div
		:class="[{'disable-allocation-row':monthlyAllocation.nonallocatedMonth},isClosed]"
		class="single-flex-row"
	>
		<div class="mh-days">
			<p class="right-td td-element-center">{{monthlyAllocation.totalWorkingDays}}</p>
		</div>
		<div class="mh-vac">
			<div class="vac-month-el">
				<p class="right-td td-element-center">{{monthlyAllocation.totalVacation}}</p>
			</div>
		</div>
		<div class="mh-sick">
			<div class="sick-el">
				<p class="right-td td-element-center">{{monthlyAllocation.totalSick}}</p>
			</div>
		</div>
		<div class="mh-other">
			<div class="others-el">
				<p class="right-td td-element-center">{{monthlyAllocation.other}}</p>
			</div>
		</div>
		<div class="mh-act">
			<div class="act-el">
				<p class="right-td td-element-center">{{monthlyAllocation.actualWorkingDays}}</p>
			</div>
		</div>
		<div v-if="turnOver==0" class="tv">
			<p class="right-td td-element-center">{{turnOver| money | truncate(7)}} €</p>
		</div>
		<div v-else class="tv">
			<p class="right-td td-element-center">
				<i
					v-tooltip.top-start="`${$options.filters.money(turnOver)} €`"
				>{{turnOver| money | truncate(7)}} €</i>
			</p>
		</div>
	</div>
</template>

<script>
import filters from "../../../../mixins/filters";
import _ from "lodash";

export default {
  name: "CustomerEngagementAllocationMonth",
  props: ["monthlyAllocation"],
  mixins: [filters],
  computed: {
    relations: function() {
      return this.$store.state.reports.customerEngagementRelations;
    },
    relation: function() {
      return this.relations.find(
        r => r.employeeProjectReleationId === this.monthlyAllocation.relationId
      );
    },
    actualWorkingDays: function() {
      // actual working days = total working days - leave days
      let monthlyAllocation = _.cloneDeep(this.monthlyAllocation);
      return (
        parseFloat(monthlyAllocation.totalWorkingDays) -
        (parseFloat(monthlyAllocation.totalVacation) +
          parseFloat(monthlyAllocation.totalSick) +
          parseFloat(this.monthlyAllocation.other))
      );
    },
    turnOver: function() {
      // get the relation
      let relation = this.relation;
      // calculate the engagement per day in hour
      let userEngagementPerDay =
        parseFloat(
          (parseFloat(relation.qEmployment) / 100) *
            relation.workingHoursCountryBased
        ) *
        (parseFloat(relation.projectEngagement) / 100);
      // calculate the user turnover per day
      let userTurnoverPerDay =
        parseFloat(relation.hourlyRate) * userEngagementPerDay;
      // calculate the monthly turn over
      let turnOver = this.actualWorkingDays * userTurnoverPerDay;
      // return 0 if NaN
      return isNaN(turnOver) ? 0 : turnOver;
    },
    isClosed:function(){
      if(this.monthlyAllocation.isClosed===true)
        return "closed-project-row"
      else
      return"open-project-row"
    }
  }
};
</script>

<style scoped>
	
	.single-flex-row{
		padding-left: 16px;
	}
	
	.single-flex-row > div{
		min-width: 44px;
		max-width: 44px;
		width: 44px;
		padding:0;
	}
	
	.single-flex-row > div p{
		text-align: center;	
	}
	
	.single-flex-row >div.tv{
		min-width: calc(100% - 236px);
		min-width: -webkit-calc(100% - 236px);
		width: calc(100% - 236px);
		width: -webkit-calc(100% - 236px);
		max-width: calc(100% - 236px);
		max-width: -webkit-calc(100% - 236px);
	}

/* 	
	.mh-days {
		min-width: 62px;
		max-width: 62px;
		width: 62px;
		padding-left: 16px;
	}

	.mh-vac {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.mh-sick {
		min-width: 44px;
		max-width: 44px;
		width: 44px;
	}

	.mh-other {
		min-width: 50px;
		max-width: 50px;
		width: 50px;
	}

	.mh-act {
		min-width: 42px;
		max-width: 42px;
		width: 42px;
	}

	.mh-tv {
		min-width: 70px;
		max-width: 70px;
		width: 70px;
	}

	.td-element-center {
		text-align: center;
		width: 23px;
		display: inline-block;
		margin: 0 auto;
	}

	.customer-engagement-alloca .month-report-bottom .mh-act .td-element-center {
		width: 30px;
		text-align: center;
	}

	.mh-other .td-element-center {
		width: 34px;
	}

	.tv .td-element-center {
		width: 55px;
		text-align: right;
	} */

	tr.disable-allocation-row {
		opacity: 0.2;
	}

	.report-master-table-set .month-table td.right-td {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
		/* height: 35px; */
	}

	.report-master-table-set .month-table td.right-td p {
		/* old code */
		/* line-height: 56px; */
		/* line-height: 34px; */
	}

	/* .vac-month-el,
	.sick-el {
		max-width: 20px;
		margin: 0 auto;
	}

	.others-el {
		max-width: 25px;
		margin: 0 auto;
		text-align: left;
	}

	.act-el {
		max-width: 42px;
		margin: 0 auto;
	} */

	.month-report-bottom .single-flex-row {
		border-bottom: none !important;
	}

	.each-moth-bottom .single-full:last-child,
	.each-moth-bottom > .month-table {
		border-bottom: none !important;
	}
	/* .act-el {
		max-width: 42px;
		margin: 0 auto;
	} */

	.month-report-bottom .single-flex-row {
		border-bottom: none !important;
	}

	.each-moth-bottom .single-full:last-child,
	.each-moth-bottom > .month-table {
		border-bottom: none !important;
	}
	div.closed-project-row {
		background: #fc5c6575;
	}
</style>